import { Injectable } from "@angular/core";
import { SettoreDTO } from "@app/shared/dto/settoreDTO";
import { SettoreVO } from "@app/shared/vo/settoreVO";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { MapperUtente } from "./mapper-utente";
import { MapperIncaricato } from "./mapper-incaricato";

@Injectable({
  providedIn: "root",
})
export class MapperSettore implements MapperInterface<SettoreDTO, SettoreVO> {
  constructor(private incaricatoMapper: MapperIncaricato) { }

  convertVoToDto(settoreVO: SettoreVO): SettoreDTO {
    // console.log("[MapperSettore] SettoreVO => SettoreDTO", settoreVO);
    if (settoreVO != null) {
      const settoreDTO = new SettoreDTO();

      settoreDTO.codice = settoreVO.codice;
      settoreDTO.nome = settoreVO.nome;
      settoreDTO.responsabile = settoreVO.responsabile;
      console.log("return", settoreDTO);
      return settoreDTO || new SettoreDTO();
    } else {
      return null;
    }
  }

  convertDtoToVo(settoreDTO: SettoreDTO): SettoreVO {
    // console.log("[MapperSettore] SettoreDTO => SettoreVO", settoreDTO);
    const settoreVO = new SettoreVO();

    settoreVO.nome = settoreDTO.nome;
    if (settoreDTO.codice) {
      settoreVO.codice = settoreDTO.codice;
    } else if (settoreDTO.cmu) {
      settoreVO.codice = settoreDTO.cmu;
    }
    settoreVO.output = settoreVO.codice + " - " + settoreVO.nome;
    settoreVO.incaricato = this.incaricatoMapper.convertDtoToVo(settoreDTO.incaricato);
    settoreVO.responsabile = settoreDTO.responsabile;
    // console.log("[MapperSettore] fine SettoreDTO => SettoreVO", settoreVO);
    return settoreVO || new SettoreVO();
  }

  convertListVoToDto(settoreVOList: SettoreVO[]): SettoreDTO[] {
    // console.log("[MapperDocumenti] documentoDTOList => documentoVOList");

    const settoreDTOList = new Array<SettoreDTO>();
    if (settoreVOList) {
      settoreVOList.forEach((vo) => {
        settoreDTOList.push(this.convertVoToDto(vo));
      });
    }

    return settoreDTOList || new Array<SettoreDTO>();
  }

  convertListDtoToVo(settoreDTOList: SettoreDTO[]): SettoreVO[] {
    /* console.log("[MapperSettori] settoreDTOList => settoreDTOList");
    console.log("settoreDTOList", settoreDTOList); */
    const settoreVOList = new Array<SettoreVO>();
    if (settoreDTOList) {
      settoreDTOList.forEach((dto) => {
        settoreVOList.push(this.convertDtoToVo(dto));
      });
    }

    return settoreVOList || new Array<SettoreVO>();
  }
}
